









import { defineComponent } from '@vue/composition-api';
import {
  toCommaFormat,
} from '@/utils';

const Treemap = defineComponent({
  props: {
    data: {},
    height: {},
  },
  setup(props) {
    const options = {
      responsive: false,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const { dataIndex } = context || '';
              const name = context.dataset.labels.name || undefined;
              if (name) {
                return [name[dataIndex], `${toCommaFormat(context.dataset.data[dataIndex]._data, 0, 0)}`];
              }
              return `${toCommaFormat(context.dataset.data[dataIndex]._data, 0, 0)}`;
            },
          },
        },
      },
    };

    return {
      options,
      toCommaFormat,
    };
  },
});

export default Treemap;
